import { ChangeDetectionStrategy, Component } from '@angular/core';

/** Action menu icon name that renders the combined print + download icon instead of a single symbol. */
export const PRINT_DOWNLOAD_ICON = 'print_download';

/**
 * Printer with a small download badge, for actions that open the document preview (print or download).
 * Takes the font size and color of its host, like a material symbol.
 */
@Component({
  selector: 'isophi-print-download-icon',
  templateUrl: './print-download-icon.component.html',
  styleUrls: ['./print-download-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PrintDownloadIconComponent {}
